import StorageAbstractFactory, { ICache } from '.';

export default class BrowserStorage implements ICache {
  private ensureInstance(): Storage {
    return StorageAbstractFactory.getSyncGlobalInstance();
  }

  clear(): Promise<void> {
    const instance = this.ensureInstance();
    return new Promise((resolve, reject) => {
      try {
        instance.clear();
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  setItem(path: string, value: any): Promise<void> {
    const instance = this.ensureInstance();

    return new Promise((resolve, reject) => {
      try {
        instance.setItem(path, value);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }

  getItem(path: string, defaultValue?: any): Promise<Nullable<string>> {
    const instance = this.ensureInstance();
    return new Promise((resolve, reject) => {
      try {
        let pre = instance.getItem(path);
        if (!pre) pre = defaultValue;
        resolve(pre);
      } catch (error) {
        reject(error);
      }
    });
  }

  removeItem(path: string): Promise<void> {
    const instance = this.ensureInstance();
    return new Promise((resolve, reject) => {
      try {
        instance.removeItem(path);
        resolve();
      } catch (error) {
        reject(error);
      }
    });
  }
}
